import React from 'react';

const LanguageSwitch = props => {
  const languageOnChange = e => {
    props.onLanguageChange(e.target.lang);
  };

  return (
    <div className="header__language_switch_new">
      <fieldset>
        <legend style={{display: 'none'}}>
          {props.language === 'fi' ? 'Suomeksi' : 'På svenska'}
        </legend>
        <div role="group" className="btn-group btn-group-toggle" onClick={e => languageOnChange(e)}>
          <p className={props.language === 'fi' ? 'bold_blue_text' : 'blue_text'} lang="fi-FI">
            Suomeksi
          </p>
          <p style={{marginLeft: '14px', marginRight: '14px', color: 'black'}}>|</p>
          <p className={props.language === 'sv' ? 'bold_blue_text' : 'blue_text'} lang="sv-FI">
            På svenska
          </p>
        </div>
      </fieldset>
    </div>
  );
};

export default LanguageSwitch;
